var _rect, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "btn/back"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9525 12.5863L15.7262 15.36C16.5398 16.1735 16.5398 17.4926 15.7262 18.3062C14.9126 19.1198 13.5935 19.1198 12.7799 18.3062L8.65512 14.1814C8.21727 13.7436 8.01505 13.1593 8.04848 12.5863C8.01506 12.0132 8.21727 11.4289 8.65512 10.9911L12.7799 6.8663C13.5935 6.05271 14.9126 6.05271 15.7262 6.8663C16.5398 7.67989 16.5398 8.99898 15.7262 9.81258L12.9525 12.5863Z",
    fill: "#E37B3C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 9,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9525 12.5863L15.7262 15.36C16.5398 16.1735 16.5398 17.4926 15.7262 18.3062C14.9126 19.1198 13.5935 19.1198 12.7799 18.3062L8.65512 14.1814C8.21727 13.7436 8.01505 13.1593 8.04848 12.5863C8.01506 12.0132 8.21727 11.4289 8.65512 10.9911L12.7799 6.8663C13.5935 6.05271 14.9126 6.05271 15.7262 6.8663C16.5398 7.67989 16.5398 8.99898 15.7262 9.81258L12.9525 12.5863Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 25,
    height: 25,
    fill: "#E37B3C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.34eeef50c2207c63cbae8efeb602a5c5.svg";
export { ForwardRef as ReactComponent };